/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Soft_Tissue_TherapyInputs */

const en_service_type_soft_tissue_therapy = /** @type {(inputs: Service_Type_Soft_Tissue_TherapyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft tissue therapy`)
};

const pl_service_type_soft_tissue_therapy = /** @type {(inputs: Service_Type_Soft_Tissue_TherapyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapia tkanek miękkich`)
};

/**
* | output |
* | --- |
* | "Soft tissue therapy" |
*
* @param {Service_Type_Soft_Tissue_TherapyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_soft_tissue_therapy = /** @type {((inputs?: Service_Type_Soft_Tissue_TherapyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Soft_Tissue_TherapyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_soft_tissue_therapy(inputs)
	return en_service_type_soft_tissue_therapy(inputs)
});